module.exports = __webpack_public_path__ + "static/media/no_internet_error.94724eb4.mp3";